<template>
    <textarea ref="froala_editor" :value="modelValue" />
</template>

<script>
export default {
    name: 'FroalaEditor',
    emits: ['update:modelValue', 'editor-ready', 'edit-document', 'edit-template'],
    props: {
        api: { type: String, default: '' },
        document: { type: Object, default: () => ({}) },
        modelValue: { type: String, default: '', },
        documentReady: { type: Boolean, default: false },
        plugins_custom: { type: Array, default: () => [] },
        maxHeight: { type: String },
        prefixUrl: { type: String, default: 'froala' },
        placeholder: { type: String, },
    },
    mounted() {
        this.initEditor();
    },
    beforeUnmount() {
        if (this.editor) { this.editor.destroy(); }
    },
    unmounted(){
        document.removeEventListener("edit-document", () => {});
        document.removeEventListener("edit-template", () => {});
    },
    watch: {
        modelValue(newVal) {
            if (this.editor && this.editor.html.get() !== newVal) {
                this.editor.html.set(newVal);
            }
        }
    },
    methods: {
        initEditor(){
            let options_extra = {
                events: {
                    'initialized': () => {
                        this.$nextTick(() => {
                            this.editor.html.set(this.modelValue);
                            if(this.maxHeight) {
                                let froala = this.editor.el.parentNode;
                                if (froala) {
                                    froala.style.maxHeight = this.maxHeight;
                                    froala.style.overflowY = 'scroll';
                                }
                            }
                        });
                    },
                    'contentChanged': () => {
                        this.$emit('update:modelValue', this.editor.html.get());
                    },
                },
                plugins_custom: this.plugins_custom,
                documentReady: this.documentReady,
                instance_uid: Math.random().toString(36).substring(2),
            };
            if(this.api) options_extra.document_api = this.api;
            if(this.document.name) {
                Object.assign(options_extra, {
                    document_name: this.document?.name,
                    footer_enable: this.document?.template_cfg.footer_enable,
                    header_enable: this.document?.template_cfg.header_enable,
                });
            }
            var options = window.FroalaOctoloInit(this.plugins_custom, options_extra);
            if(this.placeholder) options.placeholderText = this.placeholder;
            this.editor = new FroalaEditor(this.$refs.froala_editor, options);
            document.addEventListener("edit-document", (e) => { this.$emit('edit-document', e); });
            document.addEventListener("edit-template", (e) => { this.$emit('edit-template', e); });
            this.$emit('editor-ready', this.editor);
        }
    }
};
</script>
